var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { CardAdvancement } from '@cta-portal/webapp-common/lib/api/schema';
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import { useContext, useEffect, useState } from 'react';
import { CurrencyContext } from '../../context/currency';
import { DialogContext } from '../../context/dialog';
import { LoadingContext } from '../../context/loading';
import { UserContext } from '../../context/user';
import { CurrencyTokenSymbol } from '../../data/currency-tokens/currency-tokens';
import { appEnv } from '../../env';
import { DialogType } from '../../types/dialogs';
import { sleep } from '../../utils/async';
import { checkIfWalletAsEnoughCurrency } from '../../utils/balances';
import { strFloatToTokenQuantity } from '../../utils/blockchain';
import { getAssetFloorPrice } from '../../utils/imx-orders';
import { MAX_SELECTION_COUNT } from '../../utils/multi-select';
import { useInput } from '../common/use-input';
import { useImxActions } from '../imx/use-imx-actions';
export function useMultipleOrders(allOrders, refreshOrders, options) {
    var t = useI18n().t;
    var setImxLoading = useContext(LoadingContext).setImxLoading;
    var setDialogProps = useContext(DialogContext).setDialogProps;
    var _a = useContext(UserContext), user = _a.user, balances = _a.balances, selectedWallet = _a.selectedWallet, localWalletAddress = _a.localWalletAddress, fees = _a.fees, reconnectUser = _a.reconnectUser, getBalances = _a.getBalances;
    var _b = useContext(CurrencyContext), imxClient = _b.imxClient, tokens = _b.tokens, usdcAddress = _b.usdcAddress, queue = _b.queue, parseCurrencyQuantity = _b.parseCurrencyQuantity;
    var imxActions = useImxActions();
    var _c = useState([]), selectedOrders = _c[0], setSelectedOrders = _c[1];
    var _d = useState([]), lastSelectedOrderIndexes = _d[0], setLastSelectedOrderIndexes = _d[1];
    var _e = useState({ cta: 0, usdc: 0 }), totalQuantityWithFees = _e[0], setTotalQuantityWithFees = _e[1];
    var _f = useState({
        cta: {
            tokenSymbol: CurrencyTokenSymbol.CTA,
            value: '0',
            usdValue: '0',
        },
        usdc: {
            tokenSymbol: CurrencyTokenSymbol.USDC,
            value: '0',
            usdValue: '0',
        },
    }), prices = _f[0], setPrices = _f[1];
    var _g = useState({
        cta: false,
        usdc: false,
    }), notEnoughCurrency = _g[0], setNotEnoughCurrency = _g[1];
    var maxUsdPrice = useInput('');
    var _h = useState(0), maxCountToSelect = _h[0], setMaxCountToSelect = _h[1];
    var _j = useState(0), completionProgress = _j[0], setCompletionProgress = _j[1];
    var updateListingPrice = useInput('');
    var _k = useState(undefined), selectedTokenId = _k[0], setSelectedTokenId = _k[1];
    var _l = useState(undefined), updateListingsCurrencyTokenSymbol = _l[0], setUpdateListingsCurrencyTokenSymbol = _l[1];
    useEffect(function () {
        var maxUsdPriceNbr = Number.parseFloat(maxUsdPrice.value);
        var filteredOrders = __spreadArray([], allOrders, true).filter(function (order) {
            return (maxUsdPrice.value.length === 0 ||
                isNaN(maxUsdPriceNbr) ||
                (order.price.usd && order.price.usd.value <= maxUsdPriceNbr)) &&
                ((options === null || options === void 0 ? void 0 : options.fromAssets) || order.order.user !== (selectedWallet === null || selectedWallet === void 0 ? void 0 : selectedWallet.address));
        });
        if (selectedOrders.length > 0) {
            unselectedAllOrders();
        }
        setMaxCountToSelect(Math.min(MAX_SELECTION_COUNT, filteredOrders.length));
    }, [allOrders, maxUsdPrice.value]);
    useEffect(function () {
        if (options === null || options === void 0 ? void 0 : options.disabledOwned) {
            unselectedAllOrders();
        }
    }, [selectedWallet, options === null || options === void 0 ? void 0 : options.disabledOwned]);
    useEffect(function () {
        var totalQuantityWithFeesStr = totalQuantityWithFees.cta.toLocaleString('fullwide', { useGrouping: false });
        var currencyDetails = parseCurrencyQuantity(totalQuantityWithFeesStr, appEnv.ctaTokenAddress);
        var hasEnoughCurrency = checkIfWalletAsEnoughCurrency(user, balances, selectedWallet, localWalletAddress, parseCurrencyQuantity, appEnv.ctaTokenAddress, totalQuantityWithFeesStr);
        setPrices(function (value) {
            var _a, _b;
            return (__assign(__assign({}, value), { cta: {
                    tokenSymbol: CurrencyTokenSymbol.CTA,
                    value: ((_a = currencyDetails.base) === null || _a === void 0 ? void 0 : _a.displayValue) || '',
                    usdValue: ((_b = currencyDetails.usd) === null || _b === void 0 ? void 0 : _b.displayValue) || '',
                } }));
        });
        setNotEnoughCurrency(function (value) { return (__assign(__assign({}, value), { cta: !hasEnoughCurrency })); });
    }, [totalQuantityWithFees.cta, user, balances, selectedWallet === null || selectedWallet === void 0 ? void 0 : selectedWallet.address, localWalletAddress]);
    useEffect(function () {
        if (!usdcAddress)
            return;
        var totalQuantityWithFeesStr = totalQuantityWithFees.usdc.toLocaleString('fullwide', { useGrouping: false });
        var currencyDetails = parseCurrencyQuantity(totalQuantityWithFeesStr, usdcAddress);
        var hasEnoughCurrency = checkIfWalletAsEnoughCurrency(user, balances, selectedWallet, localWalletAddress, parseCurrencyQuantity, usdcAddress, totalQuantityWithFeesStr);
        setPrices(function (value) {
            var _a, _b;
            return (__assign(__assign({}, value), { usdc: {
                    tokenSymbol: CurrencyTokenSymbol.USDC,
                    value: ((_a = currencyDetails.base) === null || _a === void 0 ? void 0 : _a.displayValue) || '',
                    usdValue: ((_b = currencyDetails.usd) === null || _b === void 0 ? void 0 : _b.displayValue) || '',
                } }));
        });
        setNotEnoughCurrency(function (value) { return (__assign(__assign({}, value), { usdc: !hasEnoughCurrency })); });
    }, [totalQuantityWithFees.usdc, user, balances, selectedWallet === null || selectedWallet === void 0 ? void 0 : selectedWallet.address, localWalletAddress]);
    useEffect(function () {
        setDialogProps(function (value) {
            return (value === null || value === void 0 ? void 0 : value.custom.type) === DialogType.COMPLETION_PROGRESS
                ? __assign(__assign({}, value), { custom: __assign(__assign({}, value.custom), { progress: completionProgress }) }) : value;
        });
    }, [completionProgress]);
    useEffect(function () {
        setDialogProps(function (value) {
            if ((value === null || value === void 0 ? void 0 : value.custom.type) !== DialogType.BUY_MULTIPLE_ASSETS)
                return value;
            return selectedOrders.length > 0
                ? {
                    common: __assign(__assign({}, value.common), { title: t('common.count-assets', { count: selectedOrders.length }), actions: [
                            { highlighted: true, text: t('common.confirm'), action: function () { return buyMultipleAsset(selectedOrders); } },
                        ] }),
                    custom: __assign(__assign({}, value.custom), { orders: selectedOrders, prices: [prices.cta, prices.usdc], removeOrder: function (tokenId) { return removeOrder(tokenId); } }),
                }
                : undefined;
        });
    }, [selectedOrders, prices]);
    useEffect(function () {
        setDialogProps(function (value) {
            return (value === null || value === void 0 ? void 0 : value.custom.type) === DialogType.LIST_FOR_SALE_SINGLE
                ? {
                    common: __assign(__assign({}, value.common), { actions: [
                            {
                                highlighted: true,
                                text: t('common.confirm'),
                                action: function () {
                                    return updateListingSingle(selectedTokenId, updateListingPrice, value.custom.type === DialogType.LIST_FOR_SALE_SINGLE
                                        ? value.custom.currencyTokenSymbol
                                        : CurrencyTokenSymbol.CTA);
                                },
                                disabled: updateListingPrice.value.length === 0 || Number.parseFloat(updateListingPrice.value) === 0,
                            },
                        ] }),
                    custom: __assign(__assign({}, value.custom), { price: updateListingPrice }),
                }
                : value;
        });
    }, [updateListingPrice.value, selectedTokenId]);
    useEffect(function () {
        setDialogProps(function (value) {
            return (value === null || value === void 0 ? void 0 : value.custom.type) === DialogType.LIST_FOR_SALE_MULTIPLE
                ? {
                    common: __assign(__assign({}, value.common), { actions: [
                            {
                                highlighted: true,
                                text: t('common.confirm'),
                                action: updateListingsCurrencyTokenSymbol
                                    ? function () { return updateListingMultiple(updateListingPrice, updateListingsCurrencyTokenSymbol); }
                                    : undefined,
                                disabled: updateListingPrice.value.length === 0 || Number.parseFloat(updateListingPrice.value) === 0,
                            },
                        ] }),
                    custom: __assign(__assign({}, value.custom), { price: updateListingPrice }),
                }
                : value;
        });
    }, [updateListingPrice.value, updateListingsCurrencyTokenSymbol]);
    useEffect(function () {
        var currency;
        for (var _i = 0, selectedOrders_1 = selectedOrders; _i < selectedOrders_1.length; _i++) {
            var order = selectedOrders_1[_i];
            var orderCurrency = order.order.buy.data.token_address === appEnv.ctaTokenAddress
                ? CurrencyTokenSymbol.CTA
                : CurrencyTokenSymbol.USDC;
            if (currency === undefined) {
                currency = orderCurrency;
            }
            else if (currency !== orderCurrency) {
                currency = undefined;
                break;
            }
        }
        setUpdateListingsCurrencyTokenSymbol(currency);
    }, [selectedOrders]);
    function selectOrder(index) {
        if (!allOrders[index] || !usdcAddress)
            return;
        var values = __spreadArray([], selectedOrders, true);
        var selectedIndexes = __spreadArray([], lastSelectedOrderIndexes, true);
        var foundIndex = values.findIndex(function (value) { return value.order.order_id === allOrders[index].order.order_id; });
        var quantity = __assign({}, totalQuantityWithFees);
        if (foundIndex === -1) {
            values.push(allOrders[index]);
            selectedIndexes.push(index);
            if (allOrders[index].order.buy.data.token_address === appEnv.ctaTokenAddress) {
                quantity.cta += Number.parseFloat(allOrders[index].order.buy.data.quantity_with_fees);
            }
            else if (allOrders[index].order.buy.data.token_address === usdcAddress) {
                quantity.usdc += Number.parseFloat(allOrders[index].order.buy.data.quantity_with_fees);
            }
        }
        else {
            values.splice(foundIndex, 1);
            selectedIndexes.splice(index, 1);
            if (allOrders[index].order.buy.data.token_address === appEnv.ctaTokenAddress) {
                quantity.cta -= Number.parseFloat(allOrders[index].order.buy.data.quantity_with_fees);
            }
            else if (allOrders[index].order.buy.data.token_address === usdcAddress) {
                quantity.usdc -= Number.parseFloat(allOrders[index].order.buy.data.quantity_with_fees);
            }
        }
        setSelectedOrders(values);
        setTotalQuantityWithFees(quantity);
        setLastSelectedOrderIndexes(selectedIndexes);
    }
    function shiftSelectOrder(index) {
        if (!allOrders[index])
            return;
        var values = __spreadArray([], selectedOrders, true);
        var selectedIndexes = __spreadArray([], lastSelectedOrderIndexes, true);
        var lastIndex = lastSelectedOrderIndexes.length === 0 ? -1 : lastSelectedOrderIndexes[lastSelectedOrderIndexes.length - 1];
        var quantity = __assign({}, totalQuantityWithFees);
        if (lastIndex === -1 || lastIndex === index) {
            selectOrder(index);
            return;
        }
        var startIndex = lastIndex > index ? index : lastIndex;
        var endIndex = lastIndex > index ? lastIndex : index;
        var _loop_1 = function (i) {
            var findIndex = values.findIndex(function (value) { return value.order.order_id === allOrders[i].order.order_id; });
            if (findIndex === -1 && (!(options === null || options === void 0 ? void 0 : options.disabledOwned) || allOrders[i].order.user !== (selectedWallet === null || selectedWallet === void 0 ? void 0 : selectedWallet.address))) {
                values.push(allOrders[i]);
                if (allOrders[i].order.buy.data.token_address === appEnv.ctaTokenAddress) {
                    quantity.cta += Number.parseFloat(allOrders[i].order.buy.data.quantity_with_fees);
                }
                else if (allOrders[i].order.buy.data.token_address === usdcAddress) {
                    quantity.usdc += Number.parseFloat(allOrders[i].order.buy.data.quantity_with_fees);
                }
            }
        };
        for (var i = startIndex; i <= endIndex; i++) {
            _loop_1(i);
        }
        selectedIndexes.push(index);
        setSelectedOrders(values);
        setLastSelectedOrderIndexes(selectedIndexes);
        setTotalQuantityWithFees(quantity);
    }
    function changeOrdersSelection(count) {
        var values = [];
        var quantity = { cta: 0, usdc: 0 };
        var selectedIndexes = [];
        var maxUsdPriceNbr = Number.parseFloat(maxUsdPrice.value);
        var filteredOrders = __spreadArray([], allOrders, true).filter(function (order) {
            return (maxUsdPrice.value.length === 0 ||
                isNaN(maxUsdPriceNbr) ||
                (order.price.usd && order.price.usd.value <= maxUsdPriceNbr)) &&
                ((options === null || options === void 0 ? void 0 : options.fromAssets) || order.order.user !== (selectedWallet === null || selectedWallet === void 0 ? void 0 : selectedWallet.address));
        });
        for (var i = 0; i < count; i++) {
            values.push(filteredOrders[i]);
            if (filteredOrders[i].order.buy.data.token_address === appEnv.ctaTokenAddress) {
                quantity.cta += Number.parseFloat(filteredOrders[i].order.buy.data.quantity_with_fees);
            }
            else if (filteredOrders[i].order.buy.data.token_address === usdcAddress) {
                quantity.usdc += Number.parseFloat(filteredOrders[i].order.buy.data.quantity_with_fees);
            }
        }
        setSelectedOrders(values);
        setLastSelectedOrderIndexes(selectedIndexes);
        setTotalQuantityWithFees(quantity);
    }
    function selectAllOrders() {
        if (selectedOrders.length === allOrders.length) {
            setSelectedOrders([]);
            setTotalQuantityWithFees({ cta: 0, usdc: 0 });
        }
        else {
            var quantity = { cta: 0, usdc: 0 };
            for (var _i = 0, allOrders_1 = allOrders; _i < allOrders_1.length; _i++) {
                var order = allOrders_1[_i];
                if (order.order.buy.data.token_address === appEnv.ctaTokenAddress) {
                    quantity.cta += Number.parseFloat(order.order.buy.data.quantity_with_fees);
                }
                else if (order.order.buy.data.token_address === usdcAddress) {
                    quantity.usdc += Number.parseFloat(order.order.buy.data.quantity_with_fees);
                }
            }
            setTotalQuantityWithFees(quantity);
            setSelectedOrders(__spreadArray([], allOrders, true));
        }
        setLastSelectedOrderIndexes([]);
    }
    function removeOrder(orderId) {
        var index = allOrders.findIndex(function (order) { return order.order.order_id === orderId; });
        if (index !== -1) {
            selectOrder(index);
        }
    }
    function unselectedAllOrders() {
        setSelectedOrders([]);
        setTotalQuantityWithFees({ cta: 0, usdc: 0 });
        setUpdateListingsCurrencyTokenSymbol(undefined);
    }
    function showBuySingleAssetDialog(orderId) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        var order = allOrders.find(function (item) { return item.order.order_id === orderId; });
        if (!order)
            return;
        var hasEnoughCurrency = checkIfWalletAsEnoughCurrency(user, balances, selectedWallet, localWalletAddress, parseCurrencyQuantity, order.price.address || '', order.order.buy.data.quantity_with_fees);
        var foil = undefined;
        if (order.card)
            foil = order.card.foil;
        if (order.souvenirCard)
            foil = order.souvenirCard.foil;
        setDialogProps({
            common: {
                preTitle: t('common.about-to-buy'),
                title: ((_a = order.order.sell.data.properties) === null || _a === void 0 ? void 0 : _a.name) || '',
                close: { text: t('common.cancel'), action: hideDialog },
                actions: [
                    {
                        highlighted: true,
                        text: t('common.confirm'),
                        action: function () { return buySingleAsset(orderId); },
                        disabled: !hasEnoughCurrency || (selectedWallet === null || selectedWallet === void 0 ? void 0 : selectedWallet.address) === order.order.user,
                    },
                ],
            },
            custom: {
                type: DialogType.BUY_SINGLE_ASSET,
                imgUrl: ((_b = order.order.sell.data.properties) === null || _b === void 0 ? void 0 : _b.image_url) || '',
                tokenId: order.order.sell.data.token_id || '',
                tokenAddress: order.order.sell.data.token_address || '',
                ownerAddress: order.order.user,
                numbering: ((_c = order.card) === null || _c === void 0 ? void 0 : _c.numbering) || ((_d = order.mintPass) === null || _d === void 0 ? void 0 : _d.numbering) || ((_e = order.souvenirCard) === null || _e === void 0 ? void 0 : _e.numbering),
                metadata: {
                    rarity: (_f = order.card) === null || _f === void 0 ? void 0 : _f.rarity,
                    advancement: (_g = order.card) === null || _g === void 0 ? void 0 : _g.advancement,
                    element: (_h = order.card) === null || _h === void 0 ? void 0 : _h.element,
                    foil: foil,
                    rank: ((_j = order.card) === null || _j === void 0 ? void 0 : _j.advancement) === CardAdvancement.STANDARD ? (_k = order.card) === null || _k === void 0 ? void 0 : _k.rank : undefined,
                    grade: ((_l = order.card) === null || _l === void 0 ? void 0 : _l.grade) || ((_m = order.souvenirCard) === null || _m === void 0 ? void 0 : _m.grade) || undefined,
                    faction: (_o = order.card) === null || _o === void 0 ? void 0 : _o.faction,
                },
                notEnoughCurrency: !hasEnoughCurrency,
                price: {
                    tokenSymbol: (_p = order.price.base) === null || _p === void 0 ? void 0 : _p.symbol,
                    value: ((_q = order.price.base) === null || _q === void 0 ? void 0 : _q.displayValue) || '',
                    usdValue: ((_r = order.price.usd) === null || _r === void 0 ? void 0 : _r.displayValue) || '',
                },
            },
        });
    }
    function buySingleAsset(orderId) {
        return __awaiter(this, void 0, void 0, function () {
            var error, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!selectedWallet)
                            return [2 /*return*/];
                        setImxLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, imxActions.createTrade({
                                walletFrom: selectedWallet,
                                orderId: orderId,
                            })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        if (err_1 instanceof Error) {
                            if (err_1.message.includes('USER_VERIFIED_REQUIRED')) {
                                error = t('error.imx.kyc-required');
                            }
                            else if (err_1.message.includes('MPC_WALLET_CTA_TOKEN_IS_LOCKED')) {
                                error = t('error.imx.cta-token-locked');
                            }
                            else if (err_1.message.includes('MPC_WALLET_ASSET_IS_LOCKED')) {
                                error = t('error.imx.asset-locked');
                            }
                            else {
                                error = t('error.generic');
                            }
                        }
                        return [3 /*break*/, 4];
                    case 4:
                        if (!!error) return [3 /*break*/, 7];
                        return [4 /*yield*/, sleep(4000)];
                    case 5:
                        _a.sent();
                        return [4 /*yield*/, Promise.all([refreshOrders(), reconnectUser(), getBalances()])];
                    case 6:
                        _a.sent();
                        _a.label = 7;
                    case 7:
                        setImxLoading(false);
                        setDialogProps({
                            common: {
                                title: error ? t('common.error') : t('common.buy-now'),
                                close: { text: t('common.back'), action: hideDialog },
                            },
                            custom: {
                                type: DialogType.SIMPLE,
                                message: error || t('buy-now.success-message'),
                            },
                        });
                        return [2 /*return*/];
                }
            });
        });
    }
    function showBuyMultipleAssetsDialog() {
        setDialogProps({
            common: {
                preTitle: t('common.about-to-buy'),
                title: t('common.count-assets', { count: selectedOrders.length }),
                close: { text: t('common.cancel'), action: hideDialog },
                actions: [{ highlighted: true, text: t('common.confirm'), action: function () { return buyMultipleAsset(selectedOrders); } }],
            },
            custom: {
                type: DialogType.BUY_MULTIPLE_ASSETS,
                orders: selectedOrders,
                prices: [prices.cta, prices.usdc],
                removeOrder: function (tokenId) { return removeOrder(tokenId); },
            },
        });
    }
    function buyMultipleAsset(selectedOrdersTmp) {
        return __awaiter(this, void 0, void 0, function () {
            var error, orderIds, _i, selectedOrdersTmp_1, order, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!selectedWallet || selectedOrdersTmp.length === 0)
                            return [2 /*return*/];
                        setCompletionProgress(0);
                        setDialogProps({
                            common: {
                                title: t('buy-multiple.in-progress'),
                            },
                            custom: {
                                type: DialogType.COMPLETION_PROGRESS,
                                progress: 0,
                                total: selectedOrdersTmp.length,
                            },
                        });
                        orderIds = [];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        _i = 0, selectedOrdersTmp_1 = selectedOrdersTmp;
                        _a.label = 2;
                    case 2:
                        if (!(_i < selectedOrdersTmp_1.length)) return [3 /*break*/, 5];
                        order = selectedOrdersTmp_1[_i];
                        return [4 /*yield*/, imxActions.createTrade({
                                walletFrom: selectedWallet,
                                orderId: order.order.order_id,
                            })];
                    case 3:
                        _a.sent();
                        setCompletionProgress(function (value) { return value + 1; });
                        orderIds.push(order.order.order_id);
                        _a.label = 4;
                    case 4:
                        _i++;
                        return [3 /*break*/, 2];
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        err_2 = _a.sent();
                        if (err_2 instanceof Error) {
                            if (err_2.message.includes('USER_VERIFIED_REQUIRED')) {
                                error = t('error.imx.kyc-required');
                            }
                            else if (err_2.message.includes('MPC_WALLET_CTA_TOKEN_IS_LOCKED')) {
                                error = t('error.imx.cta-token-locked');
                            }
                            else if (err_2.message.includes('MPC_WALLET_ASSET_IS_LOCKED')) {
                                error = t('error.imx.asset-locked');
                            }
                            else {
                                error = t('error.generic');
                            }
                            console.log("[buyMultipleAsset] ".concat(err_2));
                        }
                        return [3 /*break*/, 7];
                    case 7:
                        if (!!error) return [3 /*break*/, 11];
                        return [4 /*yield*/, sleep(1000)];
                    case 8:
                        _a.sent();
                        setImxLoading(true);
                        return [4 /*yield*/, sleep(3000)];
                    case 9:
                        _a.sent();
                        return [4 /*yield*/, Promise.all([refreshOrders(), reconnectUser(), getBalances()])];
                    case 10:
                        _a.sent();
                        unselectedAllOrders();
                        _a.label = 11;
                    case 11:
                        setImxLoading(false);
                        setDialogProps({
                            common: {
                                title: error ? t('common.error') : t('common.success'),
                                close: { text: t('common.back'), action: hideDialog },
                            },
                            custom: {
                                type: DialogType.SIMPLE,
                                message: error || t('buy-multiple.success-message'),
                            },
                        });
                        setCompletionProgress(0);
                        return [2 /*return*/];
                }
            });
        });
    }
    function showCancelSingleListingDialog(orderId) {
        if (!orderId)
            return;
        setDialogProps({
            common: {
                title: t('common.cancel-listing'),
                close: { text: t('common.cancel'), action: hideDialog },
                actions: [{ highlighted: true, text: t('common.confirm'), action: function () { return cancelSingleListing(orderId); } }],
            },
            custom: {
                type: DialogType.SIMPLE,
                message: t('cancel-listing.single.message'),
            },
        });
    }
    function cancelSingleListing(orderId) {
        return __awaiter(this, void 0, void 0, function () {
            var error, err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!selectedWallet)
                            return [2 /*return*/];
                        setImxLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, imxActions.cancelOrder({ walletFrom: selectedWallet, orderId: orderId })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_3 = _a.sent();
                        if (err_3 instanceof Error) {
                            if (err_3.message.includes('USER_VERIFIED_REQUIRED')) {
                                error = t('error.imx.kyc-required');
                            }
                            else if (err_3.message.includes('MPC_WALLET_CTA_TOKEN_IS_LOCKED')) {
                                error = t('error.imx.cta-token-locked');
                            }
                            else if (err_3.message.includes('MPC_WALLET_ASSET_IS_LOCKED')) {
                                error = t('error.imx.asset-locked');
                            }
                            else {
                                error = t('error.generic');
                            }
                            console.log("[cancelListing] ".concat(err_3));
                        }
                        return [3 /*break*/, 4];
                    case 4:
                        if (!!error) return [3 /*break*/, 7];
                        return [4 /*yield*/, sleep(4000)];
                    case 5:
                        _a.sent();
                        return [4 /*yield*/, refreshOrders()];
                    case 6:
                        _a.sent();
                        _a.label = 7;
                    case 7:
                        setImxLoading(false);
                        setDialogProps({
                            common: {
                                title: error ? t('common.error') : t('common.cancel-listing'),
                                close: { text: t('common.back'), action: hideDialog },
                            },
                            custom: {
                                type: DialogType.SIMPLE,
                                message: error || t('cancel-listing.single.success-message'),
                            },
                        });
                        return [2 /*return*/];
                }
            });
        });
    }
    function showCancelMultipleListingsDialog() {
        setDialogProps({
            common: {
                title: t('common.cancel-listings'),
                close: { text: t('common.cancel'), action: hideDialog },
                actions: [{ highlighted: true, text: t('common.confirm'), action: cancelMultipleListings }],
            },
            custom: {
                type: DialogType.SIMPLE,
                message: t('cancel-listing.multiple.message'),
            },
        });
    }
    function cancelMultipleListings() {
        return __awaiter(this, void 0, void 0, function () {
            var error, _i, selectedOrders_2, order, err_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!selectedWallet)
                            return [2 /*return*/];
                        setCompletionProgress(0);
                        setDialogProps({
                            common: {
                                title: t('cancel-listing.multiple.in-progress'),
                            },
                            custom: {
                                type: DialogType.COMPLETION_PROGRESS,
                                progress: 0,
                                total: selectedOrders.length,
                            },
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        _i = 0, selectedOrders_2 = selectedOrders;
                        _a.label = 2;
                    case 2:
                        if (!(_i < selectedOrders_2.length)) return [3 /*break*/, 5];
                        order = selectedOrders_2[_i];
                        return [4 /*yield*/, imxActions.cancelOrder({ walletFrom: selectedWallet, orderId: order.order.order_id })];
                    case 3:
                        _a.sent();
                        setCompletionProgress(function (value) { return value + 1; });
                        _a.label = 4;
                    case 4:
                        _i++;
                        return [3 /*break*/, 2];
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        err_4 = _a.sent();
                        if (err_4 instanceof Error) {
                            if (err_4.message.includes('USER_VERIFIED_REQUIRED')) {
                                error = t('error.imx.kyc-required');
                            }
                            else if (err_4.message.includes('MPC_WALLET_CTA_TOKEN_IS_LOCKED')) {
                                error = t('error.imx.cta-token-locked');
                            }
                            else if (err_4.message.includes('MPC_WALLET_ASSET_IS_LOCKED')) {
                                error = t('error.imx.asset-locked');
                            }
                            else {
                                error = t('error.generic');
                            }
                            console.log("[cancelListings] ".concat(err_4));
                        }
                        return [3 /*break*/, 7];
                    case 7:
                        if (!!error) return [3 /*break*/, 11];
                        return [4 /*yield*/, sleep(1000)];
                    case 8:
                        _a.sent();
                        setImxLoading(true);
                        return [4 /*yield*/, sleep(3000)];
                    case 9:
                        _a.sent();
                        return [4 /*yield*/, refreshOrders()];
                    case 10:
                        _a.sent();
                        unselectedAllOrders();
                        _a.label = 11;
                    case 11:
                        setImxLoading(false);
                        setDialogProps({
                            common: {
                                title: error ? t('common.error') : t('common.cancel-listings'),
                                close: { text: t('common.back'), action: hideDialog },
                            },
                            custom: {
                                type: DialogType.SIMPLE,
                                message: error || t('cancel-listing.multiple.success-message'),
                            },
                        });
                        setCompletionProgress(0);
                        return [2 /*return*/];
                }
            });
        });
    }
    function showCancelMultipleOffersDialog() {
        setDialogProps({
            common: {
                title: t('common.cancel-offers'),
                close: { text: t('common.cancel'), action: hideDialog },
                actions: [{ highlighted: true, text: t('common.confirm'), action: cancelMultipleOffers }],
            },
            custom: {
                type: DialogType.SIMPLE,
                message: t('cancel-offer.multiple.message'),
            },
        });
    }
    function cancelMultipleOffers() {
        return __awaiter(this, void 0, void 0, function () {
            var error, _i, selectedOrders_3, order, err_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!selectedWallet)
                            return [2 /*return*/];
                        setCompletionProgress(0);
                        setDialogProps({
                            common: {
                                title: t('cancel-offer.multiple.in-progress'),
                            },
                            custom: {
                                type: DialogType.COMPLETION_PROGRESS,
                                progress: 0,
                                total: selectedOrders.length,
                            },
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        _i = 0, selectedOrders_3 = selectedOrders;
                        _a.label = 2;
                    case 2:
                        if (!(_i < selectedOrders_3.length)) return [3 /*break*/, 5];
                        order = selectedOrders_3[_i];
                        return [4 /*yield*/, imxActions.cancelOrder({ walletFrom: selectedWallet, orderId: order.order.order_id })];
                    case 3:
                        _a.sent();
                        setCompletionProgress(function (value) { return value + 1; });
                        _a.label = 4;
                    case 4:
                        _i++;
                        return [3 /*break*/, 2];
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        err_5 = _a.sent();
                        if (err_5 instanceof Error) {
                            if (err_5.message.includes('USER_VERIFIED_REQUIRED')) {
                                error = t('error.imx.kyc-required');
                            }
                            else if (err_5.message.includes('MPC_WALLET_CTA_TOKEN_IS_LOCKED')) {
                                error = t('error.imx.cta-token-locked');
                            }
                            else if (err_5.message.includes('MPC_WALLET_ASSET_IS_LOCKED')) {
                                error = t('error.imx.asset-locked');
                            }
                            else {
                                error = t('error.generic');
                            }
                            console.log("[cancelOffers] ".concat(err_5));
                        }
                        return [3 /*break*/, 7];
                    case 7:
                        if (!!error) return [3 /*break*/, 11];
                        return [4 /*yield*/, sleep(1000)];
                    case 8:
                        _a.sent();
                        setImxLoading(true);
                        return [4 /*yield*/, sleep(3000)];
                    case 9:
                        _a.sent();
                        return [4 /*yield*/, refreshOrders()];
                    case 10:
                        _a.sent();
                        unselectedAllOrders();
                        _a.label = 11;
                    case 11:
                        setImxLoading(false);
                        setDialogProps({
                            common: {
                                title: error ? t('common.error') : t('common.cancel-offers'),
                                close: { text: t('common.back'), action: hideDialog },
                            },
                            custom: {
                                type: DialogType.SIMPLE,
                                message: error || t('cancel-offer.multiple.success-message'),
                            },
                        });
                        setCompletionProgress(0);
                        return [2 /*return*/];
                }
            });
        });
    }
    function showUpdateListingSingleDialog(order, shredStonesCount) {
        return __awaiter(this, void 0, void 0, function () {
            var grades, metadata, floorPrice;
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            return __generator(this, function (_l) {
                switch (_l.label) {
                    case 0:
                        if (!imxClient || !usdcAddress || !fees || !order.order.sell.data.token_id)
                            return [2 /*return*/];
                        setSelectedTokenId(order.order.sell.data.token_id);
                        setDialogProps({
                            common: {
                                title: t('common.update-listing'),
                                close: { text: t('common.cancel'), action: hideDialog },
                                actions: [{ highlighted: true, text: t('common.confirm'), disabled: true }],
                            },
                            custom: {
                                type: DialogType.LIST_FOR_SALE_SINGLE,
                                currencyTokenSymbol: order.order.buy.data.token_address === appEnv.ctaTokenAddress
                                    ? CurrencyTokenSymbol.CTA
                                    : CurrencyTokenSymbol.USDC,
                                price: updateListingPrice,
                                shredStonesCount: shredStonesCount,
                                floorPriceLoading: true,
                            },
                        });
                        grades = undefined;
                        if ((_a = order.card) === null || _a === void 0 ? void 0 : _a.grade)
                            grades = [order.card.grade];
                        if ((_b = order.souvenirCard) === null || _b === void 0 ? void 0 : _b.grade)
                            grades = [order.souvenirCard.grade];
                        metadata = {
                            ian: (_c = order.card) === null || _c === void 0 ? void 0 : _c.ian,
                            id: (_d = order.souvenirCard) === null || _d === void 0 ? void 0 : _d.id,
                            name: (_e = order.order.sell.data.properties) === null || _e === void 0 ? void 0 : _e.name,
                            rarity: (_f = order.card) === null || _f === void 0 ? void 0 : _f.rarity,
                            element: (_g = order.card) === null || _g === void 0 ? void 0 : _g.element,
                            grades: grades,
                            ranks: ((_h = order.card) === null || _h === void 0 ? void 0 : _h.rank) ? [order.card.rank] : undefined,
                            foil: (_j = order.card) === null || _j === void 0 ? void 0 : _j.foil,
                        };
                        return [4 /*yield*/, getAssetFloorPrice(imxClient, usdcAddress, queue, fees, parseCurrencyQuantity, order.tokenType, metadata)];
                    case 1:
                        floorPrice = _l.sent();
                        setDialogProps({
                            common: {
                                title: t('common.update-listing'),
                                close: { text: t('common.cancel'), action: hideDialog },
                                actions: [{ highlighted: true, text: t('common.confirm'), disabled: true }],
                            },
                            custom: {
                                type: DialogType.LIST_FOR_SALE_SINGLE,
                                edit: true,
                                currencyTokenSymbol: order.order.buy.data.token_address === appEnv.ctaTokenAddress
                                    ? CurrencyTokenSymbol.CTA
                                    : CurrencyTokenSymbol.USDC,
                                price: updateListingPrice,
                                usdFloorPrice: (_k = floorPrice === null || floorPrice === void 0 ? void 0 : floorPrice.price.usd) === null || _k === void 0 ? void 0 : _k.displayValue,
                                shredStonesCount: shredStonesCount,
                                floorPriceLoading: false,
                            },
                        });
                        return [2 /*return*/];
                }
            });
        });
    }
    function updateListingSingle(tokenId, price, symbol) {
        return __awaiter(this, void 0, void 0, function () {
            var error, err_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!tokens || !usdcAddress || !tokenId || !selectedWallet)
                            return [2 /*return*/];
                        setImxLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, imxActions.listForSale({
                                walletFrom: selectedWallet,
                                sellTokenId: tokenId,
                                buyQuantity: strFloatToTokenQuantity(price.value, tokens, symbol === CurrencyTokenSymbol.CTA ? appEnv.ctaTokenAddress : usdcAddress),
                                buyTokenAddress: symbol === CurrencyTokenSymbol.CTA ? appEnv.ctaTokenAddress : usdcAddress,
                            })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_6 = _a.sent();
                        console.error(err_6);
                        if (err_6 instanceof Error) {
                            if (err_6.message.includes('USER_VERIFIED_REQUIRED')) {
                                error = t('error.imx.kyc-required');
                            }
                            else if (err_6.message.includes('MPC_WALLET_CTA_TOKEN_IS_LOCKED')) {
                                error = t('error.imx.cta-token-locked');
                            }
                            else if (err_6.message.includes('MPC_WALLET_ASSET_IS_LOCKED')) {
                                error = t('error.imx.asset-locked');
                            }
                            else {
                                error = t('error.generic');
                            }
                            console.log("[updateListingSingle] ".concat(err_6));
                        }
                        return [3 /*break*/, 4];
                    case 4:
                        if (!!error) return [3 /*break*/, 7];
                        return [4 /*yield*/, sleep(4000)];
                    case 5:
                        _a.sent();
                        return [4 /*yield*/, refreshOrders()];
                    case 6:
                        _a.sent();
                        _a.label = 7;
                    case 7:
                        setDialogProps({
                            common: {
                                title: error ? t('common.error') : t('common.update-listing'),
                                close: { text: t('common.back'), action: hideDialog },
                            },
                            custom: {
                                type: DialogType.SIMPLE,
                                message: error || t('update-listing.single.success-message'),
                            },
                        });
                        setImxLoading(false);
                        return [2 /*return*/];
                }
            });
        });
    }
    function showUpdateListingMultipleDialog() {
        if (!updateListingsCurrencyTokenSymbol)
            return;
        setDialogProps({
            common: {
                title: t('common.update-listings'),
                close: { text: t('common.cancel'), action: hideDialog },
                actions: [{ highlighted: true, text: t('common.confirm'), disabled: true }],
            },
            custom: {
                type: DialogType.LIST_FOR_SALE_MULTIPLE,
                edit: true,
                currencyTokenSymbol: updateListingsCurrencyTokenSymbol,
                price: updateListingPrice,
            },
        });
    }
    function updateListingMultiple(price, symbol) {
        return __awaiter(this, void 0, void 0, function () {
            var error, _i, selectedOrders_4, order, err_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!tokens || !usdcAddress || !selectedWallet)
                            return [2 /*return*/];
                        setImxLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        _i = 0, selectedOrders_4 = selectedOrders;
                        _a.label = 2;
                    case 2:
                        if (!(_i < selectedOrders_4.length)) return [3 /*break*/, 5];
                        order = selectedOrders_4[_i];
                        return [4 /*yield*/, imxActions.listForSale({
                                walletFrom: selectedWallet,
                                sellTokenId: order.order.sell.data.token_id || '',
                                buyQuantity: strFloatToTokenQuantity(price.value, tokens, symbol === CurrencyTokenSymbol.CTA ? appEnv.ctaTokenAddress : usdcAddress),
                                buyTokenAddress: symbol === CurrencyTokenSymbol.CTA ? appEnv.ctaTokenAddress : usdcAddress,
                            })];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        _i++;
                        return [3 /*break*/, 2];
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        err_7 = _a.sent();
                        console.error(err_7);
                        if (err_7 instanceof Error) {
                            if (err_7.message.includes('USER_VERIFIED_REQUIRED')) {
                                error = t('error.imx.kyc-required');
                            }
                            else if (err_7.message.includes('MPC_WALLET_CTA_TOKEN_IS_LOCKED')) {
                                error = t('error.imx.cta-token-locked');
                            }
                            else if (err_7.message.includes('MPC_WALLET_ASSET_IS_LOCKED')) {
                                error = t('error.imx.asset-locked');
                            }
                            else {
                                error = t('error.generic');
                            }
                            console.log("[updateListingMultiple] ".concat(err_7));
                        }
                        return [3 /*break*/, 7];
                    case 7:
                        if (!!error) return [3 /*break*/, 10];
                        return [4 /*yield*/, sleep(4000)];
                    case 8:
                        _a.sent();
                        return [4 /*yield*/, refreshOrders()];
                    case 9:
                        _a.sent();
                        unselectedAllOrders();
                        _a.label = 10;
                    case 10:
                        setDialogProps({
                            common: {
                                title: error ? t('common.error') : t('common.update-listings'),
                                close: { text: t('common.back'), action: hideDialog },
                            },
                            custom: {
                                type: DialogType.SIMPLE,
                                message: error || t('update-listing.multiple.success-message'),
                            },
                        });
                        setImxLoading(false);
                        return [2 /*return*/];
                }
            });
        });
    }
    function hideDialog() {
        setDialogProps(undefined);
        setCompletionProgress(0);
        updateListingPrice.setValue('');
    }
    return {
        selectedOrderIds: selectedOrders.map(function (order) { return order.order.order_id.toString(); }),
        prices: prices,
        notEnoughCurrency: notEnoughCurrency,
        multipleUpadteListingsDisabled: !updateListingsCurrencyTokenSymbol,
        maxCountToSelect: maxCountToSelect,
        maxUsdPrice: maxUsdPrice,
        selectOrder: selectOrder,
        shiftSelectOrder: shiftSelectOrder,
        changeOrdersSelection: changeOrdersSelection,
        selectAllOrders: selectAllOrders,
        unselectedAllOrders: unselectedAllOrders,
        showBuySingleAssetDialog: showBuySingleAssetDialog,
        showBuyMultipleAssetsDialog: showBuyMultipleAssetsDialog,
        showCancelSingleListingDialog: showCancelSingleListingDialog,
        showCancelMultipleListingsDialog: showCancelMultipleListingsDialog,
        showCancelMultipleOffersDialog: showCancelMultipleOffersDialog,
        showUpdateListingSingleDialog: showUpdateListingSingleDialog,
        showUpdateListingMultipleDialog: showUpdateListingMultipleDialog,
    };
}
